$(document).ready(function () {
  $(".botom-description-prod").click(function () {
    if($('#view-more-section-primary').hasClass("view-more-section-primary-active")){
      $('#view-more-section-primary').removeClass("view-more-section-primary-active");
      $('#view-more-section-secondary').removeClass("view-more-section-secondary-active");
      $('#btn-more').removeClass("btn-active-more");
      $('#btn-more').addClass("btn-active-more-none");
      $('#btn-less').removeClass("btn-active-more-none");
      $('#btn-less').addClass("btn-active-more");
    }else{
       $('#view-more-section-primary').addClass("view-more-section-primary-active");
      $('#view-more-section-secondary').addClass("view-more-section-secondary-active");
      $('#btn-more').removeClass("btn-active-more-none");
      $('#btn-more').addClass("btn-active-more");
      $('#btn-less').removeClass("btn-active-more");
      $('#btn-less').addClass("btn-active-more-none");
    }
  });
  $('.t4s-coll-style-1 .t4s-cat-title').append("<span class='t4s-text-right'>Voir nos produits</span>");
  
  /*section caracteristicas*/

  $(".botom-caracteristicas-prod").click(function () {
     if($('#view-more-section-primary-caracteristicas').hasClass("view-more-section-primary-active-caracteristicas")){
        $('#view-more-section-primary-caracteristicas').removeClass("view-more-section-primary-active-caracteristicas");
        $('#view-more-section-secondary-caracteristicas').removeClass("view-more-section-secondary-active-caracteristicas");
        $('#view-more-section-secondary-caracteristicas').removeClass("view-not-section");
        $('#btn-more-caracteristicas').removeClass("btn-active-more-caracteristicas");
        $('#btn-more-caracteristicas').addClass("btn-active-more-none-caracteristicas");
        $('#btn-less-caracteristicas').removeClass("btn-active-more-none-caracteristicas");
        $('#btn-less-caracteristicas').addClass("btn-active-more-caracteristicas");
    }else{
        $('#view-more-section-primary-caracteristicas').addClass("view-more-section-primary-active-caracteristicas");
        $('#view-more-section-secondary-caracteristicas').addClass("view-more-section-secondary-active-caracteristicas");
        $('#view-more-section-secondary-caracteristicas').addClass("view-not-section");
        $('#btn-more-caracteristicas').removeClass("btn-active-more-none-caracteristicas");
        $('#btn-more-caracteristicas').addClass("btn-active-more-caracteristicas");
        $('#btn-less-caracteristicas').removeClass("btn-active-more-caracteristicas");
        $('#btn-less-caracteristicas').addClass("btn-active-more-none-caracteristicas");
    }
  });

 /* $(".t4s-extra-link").detach().appendTo('#section-question'); */

  /*anclajes*/
  $('#sec_caract').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('#sec_caract_content').offset().top
        }, 500);
      });
  $('#sec_doc').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('#sec_doc_content').offset().top
        }, 500);
      });
  /*end anclajes*/
  
  
});



